/* eslint-disable react/jsx-indent */
import React from 'react';

function TermsAndConditionsLAI() {
  return (
    <div style={{
      backgroundColor: '#f5f5f5',
      color: '#111',
      padding: '24px',
      lineHeight: '1.6',
      fontFamily: 'Arial, sans-serif',
    }}
    >
      <h2>LexemeAI – Terms of Use</h2>
      <p><strong>Effective Date:</strong> 15 December 2025</p>

      <p>
        This End User License Agreement (“Agreement”) is a legal agreement between
        you (“User”) and <strong>CURVSORT PRIVATE LIMITED</strong>, governing your
        use of the LexemeAI mobile and desktop application (“App”).
      </p>

      <h3>1. License</h3>
      <p>
        The Company grants you a limited, non-exclusive, non-transferable,
        revocable license to use the App for personal or internal business use.
        The App is licensed, not sold.
      </p>

      <h3>2. Subscriptions and Usage</h3>
      <p>
        LexemeAI offers free and paid subscription tiers. Access is provided on a
        quota-based model (&quot;invocations&quot;). Invocation limits, features,
        and pricing may change at any time.
      </p>
      <p>
        LexemeAI ProAccess is an account-based subscription within the app. Payment
        is processed through the user&apos;s Apple ID. Creating a LexemeAI account is
        required only to manage per-user usage limits, subscription entitlements,
        and access across devices.
      </p>
      <h3>3. User Content</h3>
      <p>
        You retain ownership of any audio files you upload. By uploading content,
        you grant CURVSORT PRIVATE LIMITED a limited license to store and process
        such content solely to provide LexemeAI services. Uploaded audio files may
        be temporarily stored and processed to provide LexemeAI services and may be
        deleted in accordance with our Privacy Policy..
      </p>

      <h3>4. AI Output Disclaimer</h3>
      <p>
        LexemeAI uses automated and artificial intelligence technologies.
        AI-generated outputs may be inaccurate or incomplete and should not be
        relied upon as professional advice.
      </p>

      <h3>5. Acceptable Use</h3>
      <p>
        You agree not to upload content you do not have the legal right to use, or
        to misuse the App in violation of applicable laws.
      </p>

      <h3>6. Termination</h3>
      <p>
        You may delete your account at any time. The Company may suspend or
        terminate access for violations of this Agreement.
      </p>

      <h3>7. Limitation of Liability</h3>
      <p>
        To the maximum extent permitted by law, the Company shall not be liable for
        indirect or consequential damages arising from use of the App.
      </p>

      <h3>8. Governing Law</h3>
      <p>
        This Agreement is governed by the laws of India. Courts of Bangalore,
        Karnataka shall have exclusive jurisdiction.
      </p>

      <h3>9. Apple Disclaimer</h3>
      <p>
        This Agreement is between you and CURVSORT PRIVATE LIMITED, not Apple
        Inc. Apple is not responsible for the App or its content. Apple has no
        obligation to provide maintenance or support services with respect to
        the App.
      </p>
      <p>
        <strong>Contact:</strong> support@curvsort.com
      </p>
    </div>
  );
}

export default TermsAndConditionsLAI;
/* eslint-enable react/jsx-indent */
